const chip = {
  label1: 'ninguno seleccionado',
  label2: 'seleccionado(s)',
  Typography: 'seleccionar todos'
}

export default chip;
